"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = exports.APP_COLORS = void 0;
var _colors = require("@mui/material/colors");
var APP_COLORS = exports.APP_COLORS = {
  info: _colors.blue[500],
  success: _colors.green[500],
  warning: _colors.orange[700],
  error: _colors.red[800],
  chart: {
    one: _colors.teal[200],
    two: _colors.indigo[200],
    three: _colors.blue[200],
    four: _colors.green[200],
    five: _colors.purple[200]
  }
};
var getColor = exports.getColor = function getColor(level) {
  switch (level) {
    case 'info':
      return APP_COLORS.info;
    case 'success':
      return APP_COLORS.success;
    case 'warning':
      return APP_COLORS.warning;
    case 'error':
      return APP_COLORS.error;
  }
};